import IRequest from "../../IRequest"

export type TCaixaBancoHistorico = {
    id: number,
    codigo: number,
    descricao: string
}

export interface ICaixaBancosHistorico {
    reqBancos: IRequest<TCaixaBancoHistorico>,
    dataBancos: TCaixaBancoHistorico[]
}

export const defValueCaixaBancoHist: TCaixaBancoHistorico = {
    id: 0,
    codigo: 0,
    descricao: "",
}
